import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const DOCS_PROPOSAL_LANG: {
  PROPOSAL_CREATE_HEADER: MvnCodeFE;
  PROPOSAL_TEMPLATE_LABEL: MvnCodeFE;
  PROPOSAL_TEMPLATE_PLACEHOLDER: MvnCodeFE;
  PROPOSAL_TEMPLATE_PLACEHOLDER_EMPTY: MvnCodeFE;
  PROPOSAL_TITLE_LABEL: MvnCodeFE;
  PROPOSAL_TITLE_PLACEHOLDER: MvnCodeFE;
  PROPOSAL_VERSION_ADD_HEADER: MvnCodeFE;
  PROPOSAL_VERSION_LABEL: MvnCodeFE;
  PROPOSAL_VERSION_PLACEHOLDER: MvnCodeFE;
  PROPOSAL_VERSION_WARNING: MvnCodeFE;
  PROPOSAL_CREATE_SUCC: MvnCodeFE;
  PROPOSAL_CREATE_FAIL: MvnCodeFE;
  PROPOSAL_VERSION_CREATE_SUCC: MvnCodeFE;
  PROPOSAL_VERSION_CREATE_FAIL: MvnCodeFE;
  PROPOSAL_VERSION_EXPORT_SUCC: MvnCodeFE;
  PROPOSAL_VERSION_EXPORT_FAIL: MvnCodeFE;
  PROPOSAL_TITLE_PATCH_FAIL: MvnCodeFE;
  PROPOSAL_CONTENT_PATCH_FAIL: MvnCodeFE;
  PROPOSAL_CONTENT_SEARCH_FAIL: MvnCodeFE;
  PROPOSAL_CONTENT_SEARCH_EMPTY: MvnCodeFE;
  PROPOSAL_CONTENT_RECONNECT_MIRRORING: MvnCodeFE;
  PROPOSAL_CONTENT_RECONNECT_MIRRORING_TITLE: MvnCodeFE;
  PROPOSAL_CONTENT_RECONNECT_MIRRORING_MESSAGE: MvnCodeFE;
  PROPOSAL_REVISION_FETCH_FAIL: MvnCodeFE;
  PROPOSAL_REVISION_EMPTY: MvnCodeFE;
  PROPOSAL_REFERENCE_EMPTY: MvnCodeFE;
  PROPOSAL_REFERENCE_DIALOG_HEADER: MvnCodeFE;
  PROPOSAL_REFERENCE_DIALOG_TITLE: MvnCodeFE;
  PROPOSAL_VARIABLE_TEXT_DIALOG_TITLE: MvnCodeFE;
  PROPOSAL_VARIABLE_TEXT_DIALOG_HEADER: MvnCodeFE;
  PROPOSAL_FOOTNOTE_DIALOG_HEADER: MvnCodeFE;
  PROPOSAL_FOOTNOTE_DIALOG_TITLE: MvnCodeFE;
  PROPOSAL_SECTION_REMOVE_MESSAGE: MvnCodeFE;
  PROPOSAL_SECTION_REMOVE_DESC: MvnCodeFE;
  PROPOSAL_SECTION_REMOVE_SUCC: MvnCodeFE;
  PROPOSAL_SECTION_REMOVE_FAIL: MvnCodeFE;
  PROPOSAL_SECTION_TITLE_LABEL: MvnCodeFE;
  PROPOSAL_SECTION_TITLE_PLACEHOLDER: MvnCodeFE;
  PROPOSAL_SECTION_ADD_SUCC: MvnCodeFE;
  PROPOSAL_SECTION_ADD_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_HEADER: MvnCodeFE;
  PROPOSAL_COMMNET_FORM_PLACEHOLDER: MvnCodeFE;
  PROPOSAL_COMMENT_CREATE_COMMENT_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_CREATE_COMMENT_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_DELETED_SECTION_MESSAGE: MvnCodeFE;
  PROPOSAL_COMMENT_DELETED_CONTENT_MESSAGE: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_THREAD_MESSAGE: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_THREAD_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_THREAD_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_COMMENT_MESSAGE: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_COMMENT_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_DELETE_COMMENT_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_RESOLVE_COMMENT_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_RESOLVE_COMMENT_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_DIALOG_HEADER: MvnCodeFE;
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_DIALOG_CONFIRM: MvnCodeFE;
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_MESSAGE: MvnCodeFE;
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_EDIT_COMMENT_SUCC: MvnCodeFE;
  PROPOSAL_COMMENT_EDIT_COMMENT_FAIL: MvnCodeFE;
  PROPOSAL_COMMENT_CREATE_COMMENT_SELECTION_DELETED: MvnCodeFE;
} = {
  PROPOSAL_CREATE_HEADER: {
    ko: "Create Proposal",
    en: "Create Proposal",
  },
  PROPOSAL_TEMPLATE_LABEL: {
    ko: "Template",
    en: "Template",
  },
  PROPOSAL_TEMPLATE_PLACEHOLDER: {
    ko: "문서 템플릿을 선택해 주세요.",
    en: "Please choose the document template.",
  },
  PROPOSAL_TEMPLATE_PLACEHOLDER_EMPTY: {
    ko: "등록된 문서 템플릿이 없습니다.",
    en: "There is no available document template.",
  },
  PROPOSAL_TITLE_LABEL: {
    ko: "Title",
    en: "Title",
  },
  PROPOSAL_TITLE_PLACEHOLDER: {
    ko: "문서 제목을 입력해 주세요.",
    en: "Please enter the document title.",
  },
  PROPOSAL_VERSION_ADD_HEADER: {
    ko: "Add Version",
    en: "Add Version",
  },
  PROPOSAL_VERSION_LABEL: {
    ko: "Version",
    en: "Version",
  },
  PROPOSAL_VERSION_PLACEHOLDER: {
    ko: "1.0",
    en: "1.0",
  },
  PROPOSAL_VERSION_WARNING: {
    ko: "신규 버전을 등록할 경우 이전 버전의 편집이 제한됩니다.",
    en: "Editing of previous version will be restricted after registered a new version.",
  },
  PROPOSAL_CREATE_SUCC: {
    ko: "문서 생성에 성공했습니다.",
    en: "You have created a proposal successfully.",
  },
  PROPOSAL_CREATE_FAIL: {
    ko: "문서 생성에 실패했습니다. ({message})",
    en: "Failed to create a document. ({message})",
  },
  PROPOSAL_VERSION_CREATE_SUCC: {
    ko: "문서 버전 생성에 성공했습니다.",
    en: "You have created a new version of the document successfully.",
  },
  PROPOSAL_VERSION_CREATE_FAIL: {
    ko: "문서 버전 생성에 실패했습니다. ({message})",
    en: "Failed to create a new version of document. ({message})",
  },
  PROPOSAL_VERSION_EXPORT_SUCC: {
    ko: "문서 다운로드가 시작되었습니다.",
    en: "Document download has been started.",
  },
  PROPOSAL_VERSION_EXPORT_FAIL: {
    ko: "문서 다운로드에 실패했습니다. ({message})",
    en: "Failed to download a document. ({message})",
  },
  PROPOSAL_TITLE_PATCH_FAIL: {
    ko: "문서 제목 저장에 실패했습니다. ({message})",
    en: "Failed to save a document title. ({message})",
  },
  PROPOSAL_CONTENT_PATCH_FAIL: {
    ko: "문서 저장에 실패했습니다. ({message})",
    en: "Failed to save a document content. ({message})",
  },
  PROPOSAL_CONTENT_SEARCH_FAIL: {
    ko: "문서 검색에 실패했습니다. ({message})",
    en: "Failed to search library. ({message})",
  },
  PROPOSAL_CONTENT_SEARCH_EMPTY: {
    ko: "검색된 관련 문서가 없습니다. ({keyword})",
    en: "No related documents found. ({keyword})",
  },
  PROPOSAL_CONTENT_RECONNECT_MIRRORING: {
    ko: "Reconnect Mirroring",
    en: "Reconnect Mirroring",
  },
  PROPOSAL_CONTENT_RECONNECT_MIRRORING_TITLE: {
    ko: "Mirroring을 다시 연결하시겠습니까?",
    en: "Are you sure you want to reconnect mirroring?",
  },
  PROPOSAL_CONTENT_RECONNECT_MIRRORING_MESSAGE: {
    ko: "※ 연결하면 해당 섹션에 작성하신 내용은 사라지고, mirroring한 내용으로 대체됩니다.",
    en: "※ When connected, the contents written in this section disappear and is replaced with the mirrorred contents.",
  },
  PROPOSAL_REVISION_FETCH_FAIL: {
    ko: "문서 변경 이력 조회에 실패했습니다. ({message})",
    en: "Failed to fetch revision history. ({message})",
  },
  PROPOSAL_REVISION_EMPTY: {
    ko: "변경 이력이 없습니다.",
    en: "No revision history.",
  },
  PROPOSAL_REFERENCE_EMPTY: {
    ko: "문단에 입력된 참조가 자동으로 반영됩니다.",
    en: "References will be automatically reflected here.",
  },
  PROPOSAL_REFERENCE_DIALOG_HEADER: {
    ko: "Reference",
    en: "Reference",
  },
  PROPOSAL_REFERENCE_DIALOG_TITLE: {
    ko: "선택한 단락의 출처를 입력해 주세요.",
    en: "Please enter the source of the selected paragraph.",
  },
  PROPOSAL_VARIABLE_TEXT_DIALOG_HEADER: {
    ko: "Variable Text",
    en: "Variable Text",
  },
  PROPOSAL_VARIABLE_TEXT_DIALOG_TITLE: {
    ko: "Variable Text는 폴더에 포함된 모든 문서에 반영됩니다.",
    en: "Variable text will be reflected to all documents in folder.",
  },
  PROPOSAL_FOOTNOTE_DIALOG_HEADER: {
    ko: "Footnote",
    en: "Footnote",
  },
  PROPOSAL_FOOTNOTE_DIALOG_TITLE: {
    ko: "선택한 단락의 각주를 입력해 주세요.",
    en: "Please enter the footnote of the selected paragraph.",
  },
  PROPOSAL_SECTION_REMOVE_MESSAGE: {
    ko: "선택한 Section을 삭제하시겠습니까?",
    en: "Are you sure you want to delete the selected section?",
  },
  PROPOSAL_SECTION_REMOVE_DESC: {
    ko: "※ 하위 Section이 포함된 경우 모두 제거됩니다.",
    en: "※ Subsections will be removed together.",
  },
  PROPOSAL_SECTION_REMOVE_SUCC: {
    ko: "Section이 삭제되었습니다.",
    en: "Section has been removed.",
  },
  PROPOSAL_SECTION_REMOVE_FAIL: {
    ko: "Section 삭제에 실패했습니다. ({message})",
    en: "The section removal request has been failed. ({message})",
  },
  PROPOSAL_SECTION_TITLE_LABEL: {
    ko: "Section Title",
    en: "Section Title",
  },
  PROPOSAL_SECTION_TITLE_PLACEHOLDER: {
    ko: "섹션 제목을 입력해 주세요.",
    en: "Please enter the section title.",
  },
  PROPOSAL_SECTION_ADD_SUCC: {
    ko: "Section이 추가되었습니다.",
    en: "Section has been added.",
  },
  PROPOSAL_SECTION_ADD_FAIL: {
    ko: "Section 추가에 실패했습니다. ({message})",
    en: "The section addition request has been failed. ({message})",
  },
  PROPOSAL_COMMENT_HEADER: {
    ko: "댓글",
    en: "Comments",
  },
  PROPOSAL_COMMNET_FORM_PLACEHOLDER: {
    ko: "댓글을 입력해주세요.",
    en: "Add a comment.",
  },
  PROPOSAL_COMMENT_CREATE_COMMENT_SUCC: {
    ko: "댓글 등록에 성공했습니다.",
    en: "You have added a comment successfully.",
  },
  PROPOSAL_COMMENT_CREATE_COMMENT_FAIL: {
    ko: "댓글 등록에 실패했습니다. ({message})",
    en: "Failed to add a comment. ({message})",
  },
  PROPOSAL_COMMENT_DELETED_SECTION_MESSAGE: {
    ko: "삭제됐습니다.",
    en: "This section has been deleted.",
  },
  PROPOSAL_COMMENT_DELETED_CONTENT_MESSAGE: {
    ko: "삭제됐습니다.",
    en: "This paragraph has been deleted.",
  },
  PROPOSAL_COMMENT_DELETE_THREAD_MESSAGE: {
    ko: "댓글 목록을 삭제하시겠습니까?",
    en: "Are you sure you want to delete this comment thread?",
  },
  PROPOSAL_COMMENT_DELETE_THREAD_SUCC: {
    ko: "댓글 목록 삭제에 성공했습니다.",
    en: "You have deleted a comment thread successfully.",
  },
  PROPOSAL_COMMENT_DELETE_THREAD_FAIL: {
    ko: "댓글 목록 삭제에 실패했습니다. ({message})",
    en: "Failed to delete a comment thread. ({message})",
  },
  PROPOSAL_COMMENT_DELETE_COMMENT_MESSAGE: {
    ko: "댓글을 삭제하시겠습니까?",
    en: "Are you sure you want to delete a comment?",
  },
  PROPOSAL_COMMENT_DELETE_COMMENT_SUCC: {
    ko: "댓글 삭제에 성공했습니다.",
    en: "You have deleted a comment successfully.",
  },
  PROPOSAL_COMMENT_DELETE_COMMENT_FAIL: {
    ko: "댓글 삭제에 실패했습니다. ({message})",
    en: "Failed to delete a comment. ({message})",
  },
  PROPOSAL_COMMENT_RESOLVE_COMMENT_SUCC: {
    ko: "댓글 해결 처리에 성공했습니다.",
    en: "You have resolved a comment successfully.",
  },
  PROPOSAL_COMMENT_RESOLVE_COMMENT_FAIL: {
    ko: "댓글 해결 처리에 실패했습니다.({message})",
    en: "Failed to resolve a comment. ({message})",
  },
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_DIALOG_HEADER: {
    ko: "Re-Open",
    en: "Re-Open",
  },
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_DIALOG_CONFIRM: {
    ko: "Re-Open",
    en: "Re-Open",
  },
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_MESSAGE: {
    ko: "해결된 댓글을 미해결 상태로 변경하시겠습니까?",
    en: "Are you sure you want to change a comment’s status from resolved to open?",
  },
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_SUCC: {
    ko: "댓글 미해결 처리에 성공했습니다.",
    en: "You have re-opened a comment successfully.",
  },
  PROPOSAL_COMMENT_UNRESOLVE_COMMENT_FAIL: {
    ko: "댓글 미해결 처리에 실패했습니다.",
    en: "Failed to re-open a comment. ({message})",
  },
  PROPOSAL_COMMENT_EDIT_COMMENT_SUCC: {
    ko: "댓글 수정에 성공했습니다.",
    en: "You have edited a comment successfully.",
  },
  PROPOSAL_COMMENT_EDIT_COMMENT_FAIL: {
    ko: "댓글 수정에 실패했습니다. ({message})",
    en: "Failed to edit a comment. ({message})",
  },
  PROPOSAL_COMMENT_CREATE_COMMENT_SELECTION_DELETED: {
    ko: "본문에서 선택한 내용이 삭제됐습니다.",
    en: "The selected text has been deleted.",
  },
};

MvnCodeInitiate(DOCS_PROPOSAL_LANG);
